import React from 'react'

const singlesIcon = (
  <svg xmlns='http://www.w3.org/2000/svg' width='40' height='40' fill='none' viewBox='0 0 40 40'>
    <path
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeMiterlimit='10'
      strokeWidth='1.5'
      d='M30.21 33.429H10v-6.226c0-1.751 1.047-3.33 2.665-4.002 1.638-.678 4.076-1.32 7.44-1.32 3.363 0 5.802.642 7.44 1.322 1.618.67 2.665 2.249 2.665 4v6.226zM20.106 17.548c3.19 0 5.774-2.585 5.774-5.774 0-3.19-2.585-5.775-5.774-5.775s-5.774 2.586-5.774 5.775c0 3.189 2.585 5.774 5.774 5.774z'
    />
  </svg>
)

const doublesIcon = (
  <svg xmlns='http://www.w3.org/2000/svg' width='40' height='40' fill='none' viewBox='0 0 40 40'>
    <path
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeMiterlimit='10'
      strokeWidth='1.5'
      d='M24.364 33.636H4v-6.273c0-1.764 1.055-3.355 2.685-4.032 1.651-.683 4.108-1.33 7.497-1.33 3.389 0 5.846.646 7.496 1.331 1.631.675 2.686 2.267 2.686 4.031v6.273zM24.364 33.636H36V28.93c0-1.323-.753-2.517-1.918-3.023-1.179-.514-2.934-1-5.355-1-1.442 0-3.375.626-4.363.873M14.182 17.636c3.213 0 5.818-2.605 5.818-5.818 0-3.214-2.605-5.819-5.818-5.819-3.213 0-5.818 2.605-5.818 5.819 0 3.213 2.605 5.818 5.818 5.818zM28.727 20.545c2.41 0 4.364-1.954 4.364-4.364s-1.954-4.363-4.364-4.363-4.363 1.953-4.363 4.363 1.953 4.364 4.363 4.364z'
    />
  </svg>
)

const icons = {
  q3a1: singlesIcon,
  q3a2: doublesIcon,
}

export default icons
